import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Tooltip } from '@mui/material';
import React from 'react';
import { ZigTypography } from '@ui/index';

export const InfoTooltip: React.FC<{
  text?: string;
  children?: React.ReactNode;
}> = ({ children, text }) => (
  <Tooltip title={text ?? ''}>
    <ZigTypography
      sx={{
        borderBottom: '1px dotted',
        color: 'inherit',
        'font-size': 'inherit',
      }}
    >
      {children}
      <InfoOutlinedIcon
        fontSize='small'
        sx={{
          width: '0.5em',
          height: '0.5em',
          verticalAlign: 'middle',
          ml: 0.5,
          cursor: 'help',
        }}
      />
    </ZigTypography>
  </Tooltip>
);
